// Header removed per user request — site has no top nav.
// Contact modal is opened from in-page CTAs (Hero "Join Forces", CollaborationBand "Let's Join Forces").
const Nav = () => null;

export default Nav;
